// removed by extract-text-webpack-plugin
module.exports = {"root":"_1neqElw7gAfRKAWKlq7KjN","page-title":"_2x4P2snomufIlFT7DY5lBh","service-item":"_106dXkQebbYCVPYbWjmSq","service-title":"_2VWeh27_qzp3xHSHDEfN2g","actions":"_2-4RA5OcRAIsPOi51TYFt_","button":"_3UwDWWKLsP9ZxOVhFjvmFj","text":"ty7_pVYGieeiHpK1WmjKH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/onboarding/onboarding.scss
// module id = 1597
// module chunks = 0